import { createContext } from "react";
import { DeviceContextType } from "@/types/device";

export const DeviceContext = createContext<DeviceContextType | null>(null);
